import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBezierPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBezierPointer"><Path fillRule="evenodd" clipRule="evenodd" d="M11.544 11.544L22.6399 14.7143L17.4882 17.4882L14.7143 22.6399L11.544 11.544ZM14.456 14.456L15.2857 17.3601L16.0118 16.0118L17.3601 15.2857L14.456 14.456Z" fill="currentColor"/><Path d="M3 3V9H5V15H3V21H9V19H11V17H9V15H7V9H9V7H15V9H17V11H19V9H21V3H15V5H9V3H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBezierPointer;
